export const villagesMap: { [key: string]: string } = {
  en: 'villas',
  it: 'ville',
  de: 'villen',
  fr: 'villas',
};

export const experienceMap: { [key: string]: string } = {
  en: 'experiences',
  it: 'esperienze',
  fr: 'experiences',
  de: 'erfahrungen',
};

export const sicilyMap: { [key: string]: string } = {
  en: 'sicily',
  it: 'sicilia',
  de: 'sizilien',
  fr: 'sicile',
};

export const pugliaMap: { [key: string]: string } = {
  en: 'puglia',
  it: 'puglia',
  de: 'apulien',
  fr: 'pouilles',
};

export const valueToLabelSicilyZonesMap: {
  [key: string]: { [key: string]: string };
} = {
  en: {
    '1': 'west-sicily',
    '2': 'north-sicily',
    '3': 'east-sicily',
    '4': 'south-sicily',
    '5': 'north-puglia',
    '6': 'south-puglia',
    '7': 'central-puglia',
  },
  de: {
    '1': 'westsizilien',
    '2': 'nordsizilien',
    '3': 'ostsizilien',
    '4': 'sudsizilien',
    '5': 'nordapulien',
    '6': 'sudapulien',
    '7': 'zentralapulien',
  },
  fr: {
    '1': 'ouest-de-la-sicile',
    '2': 'nord-de-la-sicile',
    '3': 'est-de-la-sicile',
    '4': 'sud-de-la-sicile',
    '5': 'nord-de-la-pouilles',
    '6': 'sud-de-la-pouilles',
    '7': 'pouilles-centrales',
  },
  it: {
    '1': 'sicilia-ovest',
    '2': 'sicilia-nord',
    '3': 'sicilia-est',
    '4': 'sicilia-sud',
    '5': 'puglia-nord',
    '6': 'puglia-sud',
    '7': 'puglia-centro',
  },
};

export const sicilyZonesValuesMap: { [key: string]: string } = {
  'west-sicily': '1',
  'sicilia-ovest': '1',
  westsizilien: '1',
  'ouest-de-la-sicile': '1',
  'north-sicily': '2',
  'sicilia-nord': '2',
  nordsizilien: '2',
  'nord-de-la-sicile': '2',
  'east-sicily': '3',
  'sicilia-est': '3',
  ostsizilien: '3',
  'est-de-la-sicile': '3',
  'south-sicily': '4',
  'sicilia-sud': '4',
  sudsizilien: '4',
  'sud-de-la-sicile': '4',
};

export const sicilyZonesToCatalogIdMap: { [key: string]: string } = {
  'west-sicily': '4',
  'sicilia-ovest': '4',
  westsizilien: '4',
  'ouest-de-la-sicile': '4',
  'north-sicily': '5',
  'sicilia-nord': '5',
  nordsizilien: '5',
  'nord-de-la-sicile': '5',
  'east-sicily': '6',
  'sicilia-est': '6',
  ostsizilien: '6',
  'est-de-la-sicile': '6',
  'south-sicily': '7',
  'sicilia-sud': '7',
  sudsizilien: '7',
  'sud-de-la-sicile': '7',
  'north-puglia': '71',
  'puglia-nord': '71',
  nordapulien: '71',
  'nord-de-la-pouilles': '71',
  'south-puglia': '69',
  'puglia-sud': '69',
  sudapulien: '69',
  'sud-de-la-pouilles': '69',
  'central-puglia': '70',
  'puglia-centro': '70',
  zentralapulien: '70',
  'pouilles-centrales': '70',
};

export const phoneMap = {
  en: '0044 (0)20 3608 4505',
  it: '0039 091 687 0639',
  de: '0049 (0)30 5679 5949',
  fr: '0044 (0)20 3608 4505',
};
